import React from "react";

interface PopupMenuProps {
  children?: React.ReactNode;
}

export const PopupMenu = (props: PopupMenuProps) => (
  <div className="border border-line drop-shadow-only-3 bg-white p-6 space-y-6 w-64">{props.children}</div>
);
